export default __webpack_public_path__ + "static/media/Trash.3ecd2085.svg";